var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe-nick',{attrs:{"src":_vm.booturl}})}
var staticRenderFns = []

export { render, staticRenderFns }